module.exports = __webpack_public_path__ + "img/banner_6.22f004a2.jpg";